import React from "react";
import _ from "lodash";

import { Button, Grid } from "@mui/material";
import { IGPTQADashboardState } from "./Dashboard";
import { HStack, VStack } from "Components";

import moment from "moment";

import ScoreCard from "./ScoreCard/ScoreCard";
import ScoreCardVar from "./ScoreCard/ScoreCardVar";
import Usage from "./Usage/Usage";
import Report from "./Report/Report";

import Header from "./Header/Header";
import Feedback from "./Feedback/Feedback";

import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

interface DashboardHookProp extends IGPTQADashboardState {
  onChangeDateRange: (dates: [moment.Moment | null, moment.Moment | null] | null, formatString?: [string, string]) => void;
  fetchData: () => void;
}

const DashboardHook: React.FC<DashboardHookProp> = ({ data, base, dateRange, onChangeDateRange }) => {
  const QuickView = [7, 30, 365];

  const renderScoreCards = (data: Record<string, string | number>[]) => {
    let scorecard_items = _.map(data, (o, i) => {
      if (i === 0 || i === 1) {
        return (
          <Grid item xs={6} lg={6} key={i} style={{ display: "flex" }}>
            <ScoreCard key={i} title={o.title} values={o.values} remarks={o.remarks}></ScoreCard>
          </Grid>
        );
      } else {
        return (
          <Grid item xs={6} lg={6} key={i}>
            <ScoreCardVar key={i} title={o.title} values={o.values} remarks={o.remarks}></ScoreCardVar>
          </Grid>
        );
      }
    });
    return (
      <div className={"ScoreCards"}>
        <Grid container spacing={2}>
          {scorecard_items}
        </Grid>
      </div>
    );
  };

  const { titles, graphTitles } = base;
  return (
    <Grid container spacing={2} className="Dashboard" width={"100%"} sx={{ pt: "10px", height: "100%", width: "100%" }}>
      {/* Top Left */}
      <Grid container item xs={12} lg={7} sx={{ display: "flex", height: "50%", width: "100%", maxWidth: "100%" }}>
        <VStack width={"100%"} style={{ height: "100%", justifyContent: "space-between" }}>
          <HStack width={"100%"}>
            <Header title={titles.Usage} />

            <HStack>
              {/* Quick View */}
              {QuickView.map((o, i) => (
                <Button
                  key={i}
                  onClick={() => {
                    onChangeDateRange([moment().subtract(o - 1, "d"), moment()]);
                  }}
                >
                  {o + "D"}
                </Button>
              ))}
              <RangePicker value={[dateRange.from, dateRange.to]} showTime={false} onChange={onChangeDateRange} />
            </HStack>
          </HStack>

          <Usage title={graphTitles.DailyCov} data={data} />
        </VStack>
      </Grid>

      {/* Top Right */}
      <Grid container item xs={12} lg={5} style={{ height: "50%", paddingTop: "10px" }}>
        <VStack width="100%">
          <Report base={base} dateRange={dateRange} />
          {renderScoreCards(data && data.Overview)}
        </VStack>
      </Grid>

      {/* Bot Left */}
      <Grid container item xs={12} lg={7} style={{ height: "50%", width: "100%" }}>
        <Feedback base={base} data={data} />
      </Grid>

      {/* Bot Right */}
      <Grid item xs={12} lg={5} style={{ height: "50%" }}>
        <VStack>
          <Header title={titles.CutomerBehaviour} />
          {renderScoreCards(data && data.CustomerBehavior)}
        </VStack>
      </Grid>
    </Grid>
  );
};

export default DashboardHook;
